/**
 * Compare value for sort methods.
 * @param first First value.
 * @param second Second value.
 */
export function compareValues<T>(first: T[keyof T], second: T[keyof T]): number {
  if (typeof first === 'string' && typeof second === 'string') {
    return first.localeCompare(second);
  }
  if (typeof first === 'number' && typeof second === 'number') {
    return first - second;
  }
  if (first instanceof Date && second instanceof Date) {
    return first.getTime() - second.getTime();
  }
  return 0;
}
